if (!customElements.get('sf-load-more')) {
  customElements.define('sf-load-more', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('#product-grid');
      this.button = this.querySelector('[data-sf-more]');
      this.counter = this.querySelector('[data-sf-count]');
      this.fallback = this.querySelector('[data-sf-pagination]');
      this.error = this.querySelector('[data-sf-error]');
      if (!this.grid || !this.button) return;
      this.abort = new AbortController();
      this.key = 'sf-collection-return:' + location.pathname + location.search;
      this.restore();
      this.update();
      this.fallback.style.display = 'none';
      this.button.addEventListener('click', () => this.load(), { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (link && new URL(link.href).pathname.includes('/products/')) this.save();
      }, { capture: true, signal: this.abort.signal });
      window.addEventListener('pageshow', event => {
        if (event.persisted) {
          try { sessionStorage.removeItem(this.key); } catch {}
        }
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.request?.abort();
    }
    update() {
      const shown = this.grid.children.length;
      this.counter.textContent = this.dataset.counter.replace('__SHOWN__', shown).replace('__TOTAL__', this.dataset.total);
      const next = this.dataset.next;
      this.button.hidden = !next;
      this.button.textContent = this.dataset.label.replace('__COUNT__', Math.min(24, Number(this.dataset.total) - shown));
      this.button.disabled = false;
      this.grid.removeAttribute('aria-busy');
    }
    save() {
      try {
        sessionStorage.setItem(this.key, JSON.stringify({
          time: Date.now(), html: this.grid.innerHTML, next: this.dataset.next,
          pagination: this.fallback.innerHTML, scroll: window.scrollY
        }));
      } catch {}
    }
    restore() {
      try {
        const raw = sessionStorage.getItem(this.key);
        sessionStorage.removeItem(this.key);
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (Date.now() - saved.time > 1800000) return;
        this.grid.innerHTML = saved.html;
        this.dataset.next = saved.next || '';
        this.fallback.innerHTML = saved.pagination;
        requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, saved.scroll)));
      } catch {}
    }
    async load() {
      if (this.button.disabled || !this.dataset.next) return;
      const pageURL = new URL(this.dataset.next, location.origin);
      if (pageURL.origin !== location.origin) return;
      this.button.disabled = true;
      this.button.textContent = this.dataset.loading;
      this.error.hidden = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.request = new AbortController();
      try {
        const url = new URL(pageURL);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('HTTP');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = parsed.querySelector('sf-load-more');
        const nextGrid = incoming?.querySelector('#product-grid');
        if (!this.isConnected) return;
        if (!nextGrid || !nextGrid.children.length) throw new Error('Grid');
        const first = nextGrid.firstElementChild;
        const existing = new Set([...this.grid.querySelectorAll('a[href]')].map(a => a.getAttribute('href')));
        for (const item of [...nextGrid.children]) {
          const href = item.querySelector('a[href]')?.getAttribute('href');
          if (href && existing.has(href)) continue;
          this.grid.append(item);
          if (href) existing.add(href);
        }
        this.dataset.next = incoming.dataset.next || '';
        this.fallback.innerHTML = incoming.querySelector('[data-sf-pagination]').innerHTML;
        this.update();
        const focus = first?.querySelector('a[href]');
        if (focus?.isConnected) focus.focus({ preventScroll: true });
      } catch (error) {
        if (error.name === 'AbortError' || !this.isConnected) return;
        this.update();
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
        this.fallback.style.display = '';
      }
    }
  });
}
